import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          焦点专题
        </h2>
        <p className="text-foreground-500 text-center text-sm md:text-base mb-10">
          精选专题推荐，发现更多好电影
        </p>
        <div className="space-y-6">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="rounded-2xl overflow-hidden bg-background-50 border border-background-200/70"
            >
              <div className="flex flex-col lg:flex-row">
                <div className="lg:w-2/5 flex-shrink-0">
                  <div className="relative h-48 md:h-64 lg:h-full">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        (e.target as HTMLElement).style.display = 'none';
                      }}
                    />
                  </div>
                </div>
                <div className="flex-1 p-6 md:p-8 flex flex-col justify-center">
                  <h3 className="text-lg md:text-xl font-bold text-foreground-900 mb-3">
                    {item.title}
                  </h3>
                  <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-5">
                    {item.description}
                  </p>
                  <a
                    href="#cards"
                    onClick={(e) => {
                      e.preventDefault();
                      const el = document.querySelector('#cards');
                      if (el) {
                        const top = el.getBoundingClientRect().top + window.scrollY - 64;
                        window.scrollTo({ top, behavior: 'smooth' });
                      }
                    }}
                    className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer self-start"
                  >
                    探索更多
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}